import {withinPeriod} from 'core/Record';
import {RecordsFilter} from './types';

export function onlyWithinPeriod(period: Period): RecordsFilter {
  return function applyFilter(record: RecordEntry) {
    return withinPeriod(record, period);
  };
}
